module.exports = __webpack_public_path__ + "img/logo-app-white.7726115e.svg";